import { useTranslation } from '@wix/fe-essentials/i18n';
import { useCallback } from 'react';
import { BiCtaNames, BiModalTypes } from '../../bi/types';
import { ADVANCED_SETTINGS_ARTICLE_ID } from '../../consts';
import { useA11yWizardAdapter } from '../../hooks/use-a11y-wizard-adapter';
import { useBiLogger } from '../../hooks/use-bi-logger';
export const useExposeAdvancedSettingsModal = () => {
  const biLogger = useBiLogger();
  const {
    a11yWizardAdapter
  } = useA11yWizardAdapter();
  const {
    showDialog,
    setUserAdvancedSettings
  } = a11yWizardAdapter;
  const {
    t
  } = useTranslation();
  const showAdvancedSettingsModal = useCallback(async (hasAdvancedSettings, setHasAdvancedSettings) => {
    const modalProps = {
      ...getAdvancedSettingsModalProps(t, hasAdvancedSettings),
      articleId: ADVANCED_SETTINGS_ARTICLE_ID,
      primaryButtonOnClick: async () => {
        biLogger.modalCtaClick({
          ctaName: hasAdvancedSettings ? BiCtaNames.HideSettings : BiCtaNames.ShowSettings,
          modalType: BiModalTypes.AdvancedSettings
        });
        setUserAdvancedSettings(!hasAdvancedSettings);
        setHasAdvancedSettings(!hasAdvancedSettings);
      },
      secondaryButtonOnClick: () => {
        biLogger.modalCtaClick({
          ctaName: BiCtaNames.Cancel,
          modalType: BiModalTypes.AdvancedSettings
        });
      }
    };
    biLogger.modalView({
      modalType: BiModalTypes.AdvancedSettings
    });
    showDialog(modalProps);
  }, [biLogger, setUserAdvancedSettings, showDialog, t]);
  return {
    showAdvancedSettingsModal
  };
};
export const getAdvancedSettingsModalProps = (t, hasAdvancedSettings) => ({
  content: hasAdvancedSettings ? t('accessibility-wizard.header.expose-dev-tools.modal.content.hide') : t('accessibility-wizard.header.expose-dev-tools.modal.content.show'),
  primaryButtonText: hasAdvancedSettings ? t('accessibility-wizard.header.expose-dev-tools.modal.primary.hide') : t('accessibility-wizard.header.expose-dev-tools.modal.primary.show'),
  secondaryButtonText: t('accessibility-wizard.header.expose-dev-tools.modal.cancel'),
  theme: 'standard',
  title: hasAdvancedSettings ? t('accessibility-wizard.header.expose-dev-tools.modal.title.hide') : t('accessibility-wizard.header.expose-dev-tools.modal.title.show')
});
//# sourceMappingURL=use-expose-advanced-settings-modal.js.map